var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "user-details__body" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _vm.dealerImpersonated
              ? _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.getTranslation(
                        "user-info",
                        "invoice_address_dealer_impersonate"
                      )
                    )
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.dealerImpersonated
              ? _c("h3", [
                  _vm._v(
                    _vm._s(_vm.getTranslation("user-info", "invoice_address"))
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      class: _vm.getLabelClasses("user.address1"),
                      attrs: { for: "form-order-company_name" },
                    },
                    [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(
                            _vm.getTranslation("user-info", "name_company")
                          ) +
                          "\n                                    "
                      ),
                      _c("span", { staticClass: "req" }, [_vm._v("*")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.address1,
                        expression: "userInfo.address1",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.getInputClasses("user.address1"),
                    attrs: {
                      type: "text",
                      placeholder: _vm.getTranslation(
                        "user-info",
                        "name_company"
                      ),
                      id: "form-order-company_name",
                    },
                    domProps: { value: _vm.userInfo.address1 },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.userInfo,
                            "address1",
                            $event.target.value
                          )
                        },
                        function ($event) {
                          return _vm.removeInputError("user.address1")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.getError("user.address1")
                    ? _c("div", {
                        staticClass: "invalid-feedback",
                        domProps: {
                          textContent: _vm._s(_vm.getError("user.address1")),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.address2,
                        expression: "userInfo.address2",
                      },
                    ],
                    staticClass: "form-control empty-label",
                    class: _vm.getInputClasses("user.address2"),
                    attrs: { type: "text", id: "form-order-company_name2'" },
                    domProps: { value: _vm.userInfo.address2 },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.userInfo,
                            "address2",
                            $event.target.value
                          )
                        },
                        function ($event) {
                          return _vm.removeInputError("user.address2")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.getError("user.address2")
                    ? _c("div", {
                        staticClass: "invalid-feedback",
                        domProps: {
                          textContent: _vm._s(_vm.getError("user.address2")),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      class: _vm.getLabelClasses("user.street"),
                      attrs: { for: "form-order-street" },
                    },
                    [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.getTranslation("user-info", "street")) +
                          "\n                                    "
                      ),
                      _c("span", { staticClass: "req" }, [_vm._v("*")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.street,
                        expression: "userInfo.street",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.getInputClasses("user.street"),
                    attrs: {
                      type: "text",
                      placeholder: _vm.getTranslation("user-info", "street"),
                      id: "form-order-street",
                    },
                    domProps: { value: _vm.userInfo.street },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.userInfo, "street", $event.target.value)
                        },
                        function ($event) {
                          return _vm.removeInputError("user.street")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.getError("user.street")
                    ? _c("div", {
                        staticClass: "invalid-feedback",
                        domProps: {
                          textContent: _vm._s(_vm.getError("user.street")),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.poboxMessage.street
                ? _c("div", { staticClass: "col-12 form-group-callout mb-5" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.getTranslation("user-info", "po_box_message")
                        ) +
                        "\n                        "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      class: _vm.getLabelClasses("user.city"),
                      attrs: { for: "form-order-city" },
                    },
                    [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.getTranslation("user-info", "city")) +
                          "\n                                    "
                      ),
                      _c("span", { staticClass: "req" }, [_vm._v("*")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.city,
                        expression: "userInfo.city",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.getInputClasses("user.city"),
                    attrs: {
                      type: "text",
                      placeholder: _vm.getTranslation("user-info", "city"),
                      id: "form-order-city",
                    },
                    domProps: { value: _vm.userInfo.city },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.userInfo, "city", $event.target.value)
                        },
                        function ($event) {
                          return _vm.removeInputError("user.city")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.getError("user.city")
                    ? _c("div", {
                        staticClass: "invalid-feedback",
                        domProps: {
                          textContent: _vm._s(_vm.getError("user.city")),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      class: _vm.getLabelClasses("user.zip"),
                      attrs: { for: "form-order-zip" },
                    },
                    [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.getTranslation("user-info", "zip")) +
                          "\n                                    "
                      ),
                      _c("span", { staticClass: "req" }, [_vm._v("*")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.zip,
                        expression: "userInfo.zip",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.getInputClasses("user.zip"),
                    attrs: {
                      type: "text",
                      placeholder: _vm.getTranslation("user-info", "zip"),
                      id: "form-order-zip",
                    },
                    domProps: { value: _vm.userInfo.zip },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.userInfo, "zip", $event.target.value)
                        },
                        function ($event) {
                          return _vm.removeInputError("user.zip")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.getError("user.zip")
                    ? _c("div", {
                        staticClass: "invalid-feedback",
                        domProps: {
                          textContent: _vm._s(_vm.getError("user.zip")),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "col-form-label",
                        class: _vm.getLabelClasses("user.country_id"),
                        attrs: { for: "form-order-country" },
                      },
                      [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.getTranslation("user-info", "country")) +
                            "\n                                    "
                        ),
                        _c("span", { staticClass: "req" }, [_vm._v("*")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select2",
                      {
                        staticClass: "select2 form-control",
                        attrs: {
                          "data-width": "100%",
                          id: "form-order-country",
                          "data-theme": "bootstrap4",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.handleCountryId($event)
                          },
                        },
                        model: {
                          value: _vm.userInfo.country_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.userInfo, "country_id", $$v)
                          },
                          expression: "userInfo.country_id",
                        },
                      },
                      _vm._l(_vm.countryList, function (country) {
                        return _c(
                          "option",
                          {
                            attrs: {
                              "data-code": country.iso_code,
                              "data-is_eu": country.is_eu,
                              "data-is_cz": country.is_cz,
                            },
                            domProps: { value: country.id },
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(country.name) +
                                "\n                                    "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.getError("user.country_id")
                      ? _c("div", {
                          staticClass: "invalid-feedback",
                          domProps: {
                            textContent: _vm._s(
                              _vm.getError("user.country_id")
                            ),
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      class: _vm.getLabelClasses("user.vat_no"),
                      attrs: { for: "form-order-registration_id" },
                    },
                    [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(
                            _vm.getTranslation("user-info", "registration_id")
                          ) +
                          "\n                                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.vat_no,
                        expression: "userInfo.vat_no",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.getInputClasses("user.vat_no"),
                    attrs: {
                      type: "text",
                      placeholder: _vm.getTranslation(
                        "user-info",
                        "registration_id"
                      ),
                      id: "form-order-registration_id",
                    },
                    domProps: { value: _vm.userInfo.vat_no },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.userInfo, "vat_no", $event.target.value)
                        },
                        function ($event) {
                          return _vm.removeInputError("user.vat_no")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.getError("user.vat_no")
                    ? _c("div", {
                        staticClass: "invalid-feedback",
                        domProps: {
                          textContent: _vm._s(_vm.getError("user.vat_no")),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      class: _vm.getLabelClasses("user.vat_id"),
                      attrs: { for: "form-order-vat_number" },
                    },
                    [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(
                            _vm.getTranslation("user-info", "vat_number")
                          ) +
                          "\n\n                                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.vat_id,
                        expression: "userInfo.vat_id",
                      },
                    ],
                    staticClass: "form-control",
                    class: [_vm.getInputClasses("user.vat_id"), _vm.vatIdClass],
                    attrs: {
                      type: "text",
                      placeholder: _vm.getTranslation(
                        "user-info",
                        "vat_number"
                      ),
                      id: "form-order-vat_number",
                    },
                    domProps: { value: _vm.userInfo.vat_id },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.userInfo, "vat_id", $event.target.value)
                        },
                        function ($event) {
                          return _vm.removeInputError("user.vat_id")
                        },
                      ],
                      blur: function ($event) {
                        return _vm.checkVatInfo()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.getError("user.vat_id")
                    ? _c("div", {
                        staticClass: "invalid-feedback",
                        domProps: {
                          textContent: _vm._s(_vm.getError("user.vat_id")),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "col-12 form-group-callout mb-5",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.getTranslation("user-info", "vat_info_lines")
                  ),
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("h3", [
              _vm._v(
                _vm._s(_vm.getTranslation("user-info", "contact_information"))
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      class: _vm.getLabelClasses("user.person"),
                      attrs: { for: "form-order-person" },
                    },
                    [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.getTranslation("user-info", "name")) +
                          "\n                                    "
                      ),
                      _c("span", { staticClass: "req" }, [_vm._v("*")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.person,
                        expression: "userInfo.person",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.getInputClasses("user.person"),
                    attrs: {
                      type: "text",
                      placeholder: _vm.getTranslation("user-info", "name"),
                      id: "form-order-person",
                    },
                    domProps: { value: _vm.userInfo.person },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.userInfo, "person", $event.target.value)
                        },
                        function ($event) {
                          return _vm.removeInputError("user.person")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.getError("user.person")
                    ? _c("div", {
                        staticClass: "invalid-feedback",
                        domProps: {
                          textContent: _vm._s(_vm.getError("user.person")),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      class: _vm.getLabelClasses("user.phone"),
                      attrs: { for: "form-order-phone" },
                    },
                    [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.getTranslation("user-info", "phone")) +
                          "\n                                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.phone,
                        expression: "userInfo.phone",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.getInputClasses("user.phone"),
                    attrs: {
                      type: "text",
                      placeholder: _vm.getTranslation("user-info", "phone"),
                      id: "form-order-phone",
                    },
                    domProps: { value: _vm.userInfo.phone },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.userInfo, "phone", $event.target.value)
                        },
                        function ($event) {
                          return _vm.removeInputError("user.phone")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.getError("user.phone")
                    ? _c("div", {
                        staticClass: "invalid-feedback",
                        domProps: {
                          textContent: _vm._s(_vm.getError("user.phone")),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      class: _vm.getLabelClasses("user.email"),
                      attrs: { for: "form-order-email" },
                    },
                    [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.getTranslation("user-info", "email")) +
                          "\n                                    "
                      ),
                      _c("span", { staticClass: "req" }, [_vm._v("*")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.email,
                        expression: "userInfo.email",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.getInputClasses("user.email"),
                    attrs: {
                      type: "text",
                      placeholder: _vm.getTranslation("user-info", "email"),
                      id: "form-order-email",
                    },
                    domProps: { value: _vm.userInfo.email },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.userInfo, "email", $event.target.value)
                        },
                        function ($event) {
                          return _vm.removeInputError("user.email")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.getError("user.email")
                    ? _c("div", {
                        staticClass: "invalid-feedback",
                        domProps: {
                          innerHTML: _vm._s(_vm.getError("user.email")),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.hasDelivery
          ? _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.getTranslation("user-info", "delivery_options")
                    ) + " "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      class: _vm.getLabelClasses("user.phone_for_delivery"),
                      attrs: { for: "form-order-delivery_phone" },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.getTranslation(
                              "user-info",
                              "phone_for_delivery"
                            )
                          ) +
                          "\n                            "
                      ),
                      _vm.deliveryPrice()
                        ? _c("span", { staticClass: "req" }, [_vm._v("*")])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.delivery_phone,
                        expression: "userInfo.delivery_phone",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.getInputClasses("user.delivery_phone"),
                    attrs: {
                      type: "text",
                      placeholder: _vm.getTranslation(
                        "user-info",
                        "phone_for_delivery"
                      ),
                      id: "form-order-delivery_phone",
                    },
                    domProps: { value: _vm.userInfo.delivery_phone },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.userInfo,
                            "delivery_phone",
                            $event.target.value
                          )
                        },
                        function ($event) {
                          return _vm.removeInputError("user.delivery_phone")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm.getError("user.delivery_phone")
                    ? _c("div", {
                        staticClass: "invalid-feedback",
                        domProps: {
                          textContent: _vm._s(
                            _vm.getError("user.delivery_phone")
                          ),
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasDelivery
          ? _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "a",
                  {
                    staticClass: "different-address ",
                    class: _vm.deliveryExpanded ? "" : "collapsed",
                    attrs: {
                      "data-toggle": "collapse",
                      href: "#invoice-address",
                      role: "button",
                      "aria-expanded": "false",
                      "aria-controls": "invoice-address",
                      "aria-expanded": _vm.deliveryExpanded ? "true" : "false",
                    },
                  },
                  [
                    _c("span", { staticClass: "plus" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            role: "img",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 384 512",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "currentColor",
                              d: "M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "minus" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            role: "img",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 384 512",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "currentColor",
                              d: "M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.getTranslation("user-info", "shipping_address")
                        ) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "collapse",
                    class: _vm.deliveryExpanded ? "show" : "",
                    attrs: { id: "invoice-address" },
                  },
                  [
                    _c("div", { staticClass: "invoice-address__body" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-form-label",
                            class: _vm.getLabelClasses(
                              "user.shipping_address1"
                            ),
                            attrs: { for: "form-order-shipping-address1" },
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.getTranslation(
                                    "user-info",
                                    "name_company"
                                  )
                                ) +
                                "\n\n                                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userInfo.shipping_address1,
                              expression: "userInfo.shipping_address1",
                            },
                          ],
                          staticClass: "form-control",
                          class: _vm.getInputClasses("user.shipping_address1"),
                          attrs: {
                            type: "text",
                            placeholder: _vm.getTranslation(
                              "user-info",
                              "name_company"
                            ),
                            id: "form-order-shipping-address1",
                          },
                          domProps: { value: _vm.userInfo.shipping_address1 },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.userInfo,
                                  "shipping_address1",
                                  $event.target.value
                                )
                              },
                              function ($event) {
                                return _vm.removeInputError(
                                  "user.shipping_address1"
                                )
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.getError("user.shipping_address1")
                          ? _c("div", {
                              staticClass: "invalid-feedback",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getError("user.shipping_address1")
                                ),
                              },
                            })
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userInfo.shipping_address2,
                                  expression: "userInfo.shipping_address2",
                                },
                              ],
                              staticClass: "form-control empty-label",
                              class: _vm.getInputClasses(
                                "user.shipping_address2"
                              ),
                              attrs: {
                                type: "text",
                                id: "form-order-shipping-address2",
                              },
                              domProps: {
                                value: _vm.userInfo.shipping_address2,
                              },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.userInfo,
                                      "shipping_address2",
                                      $event.target.value
                                    )
                                  },
                                  function ($event) {
                                    return _vm.removeInputError(
                                      "user.shipping_address2"
                                    )
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.getError("user.shipping_address2")
                              ? _c("div", {
                                  staticClass: "invalid-feedback",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.getError("user.shipping_address2")
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              {
                                staticClass: "col-form-label",
                                class: _vm.getLabelClasses(
                                  "user.shipping_street"
                                ),
                                attrs: { for: "form-order-shipping-street" },
                              },
                              [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(
                                      _vm.getTranslation("user-info", "street")
                                    ) +
                                    "\n                                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userInfo.shipping_street,
                                  expression: "userInfo.shipping_street",
                                },
                              ],
                              staticClass: "form-control",
                              class: _vm.getInputClasses(
                                "user.shipping_street"
                              ),
                              attrs: {
                                type: "text",
                                placeholder: _vm.getTranslation(
                                  "user-info",
                                  "street"
                                ),
                                id: "form-order-shipping-street",
                              },
                              domProps: { value: _vm.userInfo.shipping_street },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.userInfo,
                                      "shipping_street",
                                      $event.target.value
                                    )
                                  },
                                  function ($event) {
                                    return _vm.removeInputError(
                                      "user.shipping_street"
                                    )
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.getError("user.shipping_street")
                              ? _c("div", {
                                  staticClass: "invalid-feedback",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.getError("user.shipping_street")
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.poboxMessage.shipping_street
                          ? _c(
                              "div",
                              { staticClass: "col-12 form-group-callout mb-5" },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.getTranslation(
                                        "user-info",
                                        "po_box_message"
                                      )
                                    ) +
                                    "\n                                "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              {
                                staticClass: "col-form-label",
                                class: _vm.getLabelClasses("user.city"),
                                attrs: { for: "form-order-shipping-city" },
                              },
                              [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(
                                      _vm.getTranslation("user-info", "city")
                                    ) +
                                    "\n                                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userInfo.shipping_city,
                                  expression: "userInfo.shipping_city",
                                },
                              ],
                              staticClass: "form-control",
                              class: _vm.getInputClasses("user.shipping_city"),
                              attrs: {
                                type: "text",
                                placeholder: _vm.getTranslation(
                                  "user-info",
                                  "city"
                                ),
                                id: "form-order-shipping-city",
                              },
                              domProps: { value: _vm.userInfo.shipping_city },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.userInfo,
                                      "shipping_city",
                                      $event.target.value
                                    )
                                  },
                                  function ($event) {
                                    return _vm.removeInputError(
                                      "user.shipping_city"
                                    )
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.getError("user.shipping_city")
                              ? _c("div", {
                                  staticClass: "invalid-feedback",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.getError("user.shipping_city")
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              {
                                staticClass: "col-form-label",
                                class: _vm.getLabelClasses("user.shipping_zip"),
                                attrs: { for: "form-order-shipping-zip" },
                              },
                              [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(
                                      _vm.getTranslation("user-info", "zip")
                                    ) +
                                    "\n                                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userInfo.shipping_zip,
                                  expression: "userInfo.shipping_zip",
                                },
                              ],
                              staticClass: "form-control",
                              class: _vm.getInputClasses("user.shipping_zip"),
                              attrs: {
                                type: "text",
                                placeholder: _vm.getTranslation(
                                  "user-info",
                                  "zip"
                                ),
                                id: "form-order-shipping-zip",
                              },
                              domProps: { value: _vm.userInfo.shipping_zip },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.userInfo,
                                      "shipping_zip",
                                      $event.target.value
                                    )
                                  },
                                  function ($event) {
                                    return _vm.removeInputError(
                                      "user.shipping_zip"
                                    )
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.getError("user.shipping_zip")
                              ? _c("div", {
                                  staticClass: "invalid-feedback",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.getError("user.shipping_zip")
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "col-form-label",
                                  class: _vm.getLabelClasses(
                                    "user.shipping_country_id"
                                  ),
                                  attrs: { for: "form-order-shipping-country" },
                                },
                                [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(
                                        _vm.getTranslation(
                                          "user-info",
                                          "country"
                                        )
                                      ) +
                                      "\n                                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select2",
                                {
                                  staticClass: "form-control select2",
                                  attrs: {
                                    "data-width": "100%",
                                    id: "form-order-shipping-country",
                                    "data-theme": "bootstrap4",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.handleShippingCountry($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.userInfo.shipping_country_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.userInfo,
                                        "shipping_country_id",
                                        $$v
                                      )
                                    },
                                    expression: "userInfo.shipping_country_id",
                                  },
                                },
                                _vm._l(_vm.countryList, function (country) {
                                  return _c(
                                    "option",
                                    {
                                      attrs: {
                                        "data-code": country.iso_code,
                                        "data-is_eu": country.is_eu,
                                        "data-is_cz": country.is_cz,
                                      },
                                      domProps: { value: country.id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(country.name) +
                                          "\n                                            "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _vm.getError("user.shipping_country_id")
                                ? _c("div", {
                                    staticClass: "invalid-feedback",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.getError("user.shipping_country_id")
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group-callout py-3 mb-4" }, [
                  _c("p", { staticClass: "my-2" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.getTranslation(
                            "user-info",
                            "fill_in_for_different_address"
                          )
                        ) +
                        "\n                        "
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.state.cart.hasDelivery
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "delivery-cost" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.getTranslation("user-info", "delivery_price")
                      ) +
                      " "
                  ),
                  _c("span", {
                    staticClass: "ml-auto text-black",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.priceFormat(_vm.deliveryPrice(), true)
                      ),
                    },
                  }),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-3" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.getTranslation("user-info", "licence_agreement_privacy")
                )
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              !_vm.dealerImpersonated
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      { staticClass: "custom-control custom-checkbox " },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userInfo.newsletter,
                              expression: "userInfo.newsletter",
                            },
                          ],
                          staticClass: "custom-control-input",
                          attrs: { id: "newsletter", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.userInfo.newsletter)
                              ? _vm._i(_vm.userInfo.newsletter, null) > -1
                              : _vm.userInfo.newsletter,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.userInfo.newsletter,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.userInfo,
                                      "newsletter",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.userInfo,
                                      "newsletter",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.userInfo, "newsletter", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", {
                          staticClass: "custom-control-label ",
                          attrs: { for: "newsletter" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getTranslation(
                                "user-info",
                                "newsletter_label",
                                {
                                  newsletter_url:
                                    _vm.configUrls.web_privacy_newsletter_url,
                                }
                              )
                            ),
                          },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "div",
                  {
                    staticClass: "custom-control custom-checkbox",
                    class: _vm.getInputClasses("agreement"),
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userInfo.agreement,
                          expression: "userInfo.agreement",
                        },
                      ],
                      staticClass: "custom-control-input",
                      attrs: { id: "agreement", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.userInfo.agreement)
                          ? _vm._i(_vm.userInfo.agreement, null) > -1
                          : _vm.userInfo.agreement,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.userInfo.agreement,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.userInfo,
                                    "agreement",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.userInfo,
                                    "agreement",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.userInfo, "agreement", $$c)
                            }
                          },
                          function ($event) {
                            return _vm.removeInputError("agreement")
                          },
                        ],
                      },
                    }),
                    _vm._v(" "),
                    !_vm.dealerImpersonated
                      ? _c("label", {
                          staticClass: "custom-control-label ",
                          attrs: { for: "agreement" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getTranslation("user-info", "agree_label", {
                                agreement_url:
                                  _vm.configUrls.web_licence_agreement_url,
                              }) + "<span class=req>*</span>"
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dealerImpersonated
                      ? _c("label", {
                          staticClass: "custom-control-label ",
                          attrs: { for: "agreement" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getTranslation(
                                "user-info",
                                "dealer_agree_label",
                                {
                                  agreement_url:
                                    _vm.configUrls.web_licence_agreement_url,
                                }
                              ) + "<span class=req>*</span>"
                            ),
                          },
                        })
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.getError("agreement")
                  ? _c("div", {
                      staticClass: "invalid-feedback",
                      domProps: {
                        textContent: _vm._s(_vm.getError("agreement")),
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "div",
                  {
                    staticClass: "custom-control custom-checkbox",
                    class: _vm.getInputClasses("privacy"),
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userInfo.privacy,
                          expression: "userInfo.privacy",
                        },
                      ],
                      staticClass: "custom-control-input",
                      attrs: { id: "privacy", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.userInfo.privacy)
                          ? _vm._i(_vm.userInfo.privacy, null) > -1
                          : _vm.userInfo.privacy,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.userInfo.privacy,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.userInfo,
                                    "privacy",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.userInfo,
                                    "privacy",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.userInfo, "privacy", $$c)
                            }
                          },
                          function ($event) {
                            return _vm.removeInputError("privacy")
                          },
                        ],
                      },
                    }),
                    _vm._v(" "),
                    !_vm.dealerImpersonated
                      ? _c("label", {
                          staticClass: "custom-control-label ",
                          attrs: { for: "privacy" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getTranslation("user-info", "privacy_label", {
                                privacy_url:
                                  _vm.configUrls.web_privacy_policy_url,
                              }) + "<span class=req>*</span>"
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dealerImpersonated
                      ? _c("label", {
                          staticClass: "custom-control-label ",
                          attrs: { for: "privacy" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getTranslation(
                                "user-info",
                                "dealer_privacy_label",
                                {
                                  privacy_url:
                                    _vm.configUrls.web_privacy_policy_url,
                                }
                              ) + "<span class=req>*</span>"
                            ),
                          },
                        })
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.getError("privacy")
                  ? _c("div", {
                      staticClass: "invalid-feedback",
                      domProps: {
                        textContent: _vm._s(_vm.getError("privacy")),
                      },
                    })
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.showPromoBox()
          ? _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      attrs: { for: "form-order-promo_code" },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.getTranslation("user-info", "promo_code")
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userInfo.promo_code,
                        expression: "userInfo.promo_code",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: _vm.getTranslation(
                        "user-info",
                        "promo_code"
                      ),
                      id: "form-order-promo_code",
                    },
                    domProps: { value: _vm.userInfo.promo_code },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.userInfo,
                          "promo_code",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "form-group mt-3 mb-5" }, [
              _c("label", { attrs: { for: "order_note" } }, [
                _vm._v(_vm._s(_vm.getTranslation("front", "NOTE"))),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userInfo.note,
                    expression: "userInfo.note",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "order_note", rows: "5", cols: "40" },
                domProps: { value: _vm.userInfo.note },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.userInfo, "note", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "user-details__footer" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-back",
            attrs: { href: _vm.navigation.licences_setup },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "15",
                  height: "13",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 448 512",
                },
              },
              [
                _c("path", {
                  attrs: {
                    fill: "currentColor",
                    d: "M231.536 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113L238.607 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z",
                  },
                }),
              ]
            ),
            _vm._v(
              "\n                " +
                _vm._s(_vm.getTranslation("front", "back")) +
                "\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "btn btn-primary btn-order submitbtn submitUserInfo continue",
            attrs: { type: "submit" },
            on: {
              click: function ($event) {
                return _vm.checkUserInfo()
              },
            },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.getTranslation("front", "continue")) +
                "\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-order continue-spinner d-none",
            attrs: { href: "javascript:;" },
          },
          [
            _c(
              "span",
              { staticClass: "d-flex align-items-center" },
              [
                _c("b-spinner", {
                  attrs: { small: "", variant: "light", label: "Loading..." },
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.getTranslation("front", "loading")) +
                    "\n                "
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "bv-modal-warning", centered: "", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c("div", { staticClass: "modal-title__icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          role: "img",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 512 512",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "currentColor",
                            d: "M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.getTranslation("key-setup-vue", "warning"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "d-block text-center" }, [
            _c("p", [_vm._v(_vm._s(_vm.submitErrorMessage))]),
            _vm._v(" "),
            _c("br"),
            _c("br"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-3 mx-auto",
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.getTranslation("front", "close")))]
              ),
              _vm._v(" "),
              _vm.submitError != -1
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "mt-3 mx-auto btn btn-secondary",
                        attrs: { href: _vm.baseUrl + "/empty-cart" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.getTranslation("front", "empty_cart"))
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "bv-modal-duplicate", centered: "", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c("div", { staticClass: "modal-title__icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          role: "img",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 512 512",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "currentColor",
                            d: "M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.getTranslation("user-info", "warning"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "d-block text-center" }, [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.getTranslation("user-info", "modal_existing_line_1")
                ),
              },
            }),
            _vm._v(" "),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.duplicateUserMessage) },
            }),
            _vm._v(" "),
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.getTranslation("user-info", "modal_existing_line_2")
                ),
              },
            }),
            _vm._v(" "),
            _c("br"),
            _c("br"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "a",
                {
                  staticClass: "mt-3 mx-auto btn btn-secondary",
                  attrs: { href: _vm.baseUrl + "/login" },
                },
                [_vm._v(_vm._s(_vm.getTranslation("auth", "login")))]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "mt-3 mx-auto",
                  on: {
                    click: function ($event) {
                      return _vm.confirmPotentialDuplicate()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.getTranslation("front", "continue")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }